<template>
<div class="md-example-child md-example-child-skeleton md-example-child-skeleton-2 home-skeleton">
  <md-field>
    <div class="skeleton-header">
      <md-skeleton class="skeleton-creater" :row="1">
      </md-skeleton>
      <md-skeleton  class="skeleton-tabs" :row="1">
      </md-skeleton>
      <md-skeleton class="skeleton-search" :row="1">
      </md-skeleton>
    </div>
    <div class="skeleton-content">
      <div class="content-left">
        <md-skeleton avatar class="skeleton-avatar" :row="0">
        </md-skeleton>
        <md-skeleton avatar class="skeleton-avatar" :row="0">
        </md-skeleton>
        <md-skeleton avatar class="skeleton-avatar" :row="0">
        </md-skeleton>
        <md-skeleton avatar class="skeleton-avatar" :row="0">
        </md-skeleton>
      </div>
      <div class="content-footer">
        <md-skeleton class="skeleton-footer" :row="1">
        </md-skeleton>
        <md-skeleton class="skeleton-footer" :row="1">
        </md-skeleton>
      </div>
    </div>
  </md-field>
</div>
</template>
<script>
import { Skeleton, Field, CellItem } from 'mand-mobile';
export default {
  name: 'HomeSkeleton',
  components: {
    [Skeleton.name]: Skeleton,
    [Field.name]: Field,
    [CellItem.name]: CellItem
  }
};
</script>
<style lang="scss">
.home-skeleton {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999; // 为了遮挡弹框
    width: 100%;
    height: 100%;
    background-color: #fff;
    .md-field {
      padding: 0;
      .skeleton-header {
        margin-top: 10px;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 24px;
        .skeleton-creater {
          width: 50px;
          height: 24px;
        }
        .skeleton-tabs {
          flex: 1;
          height: 24px;
          .md-skeleton-content {
            display: flex;
            justify-content: center;
          }
        }
        .skeleton-search {
          width: 50px;
          height: 24px;
        }
      }
      .skeleton-content {
        height: calc(100vh - 48px);
        margin: 10px 0;
        // background: linear-gradient(90deg,#f3f3f6 8%,#f8faff 18%,#f3f3f6 33%);
        .content-left {
          position: absolute;
          right: 0px;
          top: 50%;
          transform: translateY(-50%);
          .md-skeleton-avatar {
            width: 50px;
            height: 50px;
            margin-bottom: 10px;
          }
        }
        .content-footer {
          position: absolute;
          left: 10px;
          bottom: 119px;
          width: 100%;
          .skeleton-footer {
            height: 24px;
            margin-bottom: 10px;
          }
        }
      }
    }
}
</style>
